import React, { useEffect, useState } from 'react';
import { useBreadcrumbs, useUser } from '../hooks';
import { bindClick } from '../SiteUtil';
import { Header, Table, Groupper, Toast, Button, Icon, Toolbar, Label, Items, Message } from 'react-frontier';
import { UserClass, UserType, UserAsset, Asset, AssetAddOptions, UserTag, SetLoading } from '../SiteClasses';
import { useParams, Link } from 'react-router-dom';
import { Dropdown, Modal, ModalActions } from 'semantic-ui-react';
import { AssetViewModal, AddAssetModal } from '../components';
import UserAccess from '../UserAccess';
import UserAccessConfig from '../components/UserAccessConfig';
import moment from 'moment';
import API from '../API';

interface UsersViewProps{
	
}

enum Modals{
	CREATE_ASSET = 1,
	VIEW_ASSET = 2,
	DELETE_ASSET = 3,
	TAGS = 4
}

var getTypeName = (id: number) => UserType[id];

var UserView = (props: UsersViewProps)=>{
	var params = useParams<{ id: string }>();
	var { hasAccess, user } = useUser();
	var { setTitle } = useBreadcrumbs();
	var [loadError, setLoadError] = useState<string>(null);
	var [userData, setUserData] = useState<UserClass>(null);
	var [addAccess, setAddAccess] = useState<number[]>([]);
	var [errorPrompts, setErrorPrompts] = useState<string[]>([]);
	var [selectedAsset, setSelectedAsset] = useState<UserAsset>(null);
	var [shownModal, setShownModal] = useState<number>(null);
	var [selectedTags, setSelectedTags] = useState<number[]>([]);
	var [modalPrompts, setModalPrompts] = useState<string[]>([]);
	var [allTags, setAllTags] = useState<UserTag[]>(null);

	useEffect(()=>{
		setTitle('Usuario #'+parseInt(params.id));
		API.getUser(parseInt(params.id), true, true).then(res=>{
			if(res.error) setLoadError(res.message);
			setAddAccess(res.data.access)
			setUserData(res.data);
		}).catch(err=>{
			setLoadError('Hubo un error cargando el usuario (LCL-1)');
		})
	}, []);

	var updateAccess = (setLoading: (l: boolean)=>void)=>{
		setLoading(true);
		API.userAccess(userData.user_id, addAccess).then(res=>{
			if(res.error) return setErrorPrompts([res.message]);
			Toast.success('Permisos actualizados!');

			var u = {...userData}
			u.access = addAccess;
			setUserData(u);
		}).catch(err=>{
			setErrorPrompts(['Hubo un error inesperado actualizando el usuario (U-UPD-1)']);
		}).finally(()=>{
			setLoading(false);
		});
	};

	var onAssetAdded = (asset: Asset, options: AssetAddOptions)=>{
		var u = { ...userData };
		if(!u.assets) u.assets = [];
		u.assets.push({
			...asset,
			user_asset_type: options.user_asset_type,
			user_asset_type_name: options.user_asst_type_name,
		});
		setUserData(u);
	};

	var onAssetDeleted = (asset_id: number)=>{
		var u = { ...userData };
		u.assets = u.assets.filter(asset => asset.asset_id !== asset_id);
		setUserData(u);
	};

	var showTagsModal = ()=>{
		setSelectedTags((userData.tags || []).map(t => t.tag_id));
		setShownModal(Modals.TAGS);
		
		if(!allTags){
			API.getAllTags().then(res=>{
				if(res.error) return Toast.error(res.message);
				setAllTags(res.data);
			}).catch(err=>{
				Toast.error('Hubo un error cargando las etiquetas (U-LT-1)');
			})
		}
	}

	var editTags = async (setLoading: SetLoading)=>{
		setLoading(true);
		var allTagIds = selectedTags;
		
		API.editUserTags(userData.user_id, allTagIds).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			Toast.success('Etiquetas actualizadas!');
			
			var newTags = allTags.filter(tag => allTagIds.includes(tag.tag_id));
			setUserData(prev => ({ ...prev, tags: newTags }));
			setShownModal(null);
		}).catch(err=>{
			setModalPrompts(['Hubo un error inesperado actualizando las etiquetas. (U-UOL-1)']);
		}).finally(()=>{
			setLoading(false);
		})
	};
	
	var downloadPayments = ()=>{
		API.downloadPaymentsReport(`${userData.first_name} ${userData.last_name}`, userData.user_id).then(res=>{
			if(res.error) return Toast.error(res.message);
		}).catch(()=>{
			Toast.error('Hubo un error descargando los pagos (UV-PAY-1)');
		});
	};

	if(loadError) { return <Header text='Error' subtext={loadError} />};
	if(!userData) { return <Header text='Cargando datos' loading/> };

	return <div className='ar user-screen'>
		<Groupper
			title={'Información de usuario'}
			width={500}
			style={{ marginTop: 20 }}
			fitted
		>
			<Toolbar style={{ borderRadius: 0, boxShadow: 'none', borderLeft: '0', borderTop: '0', borderRight: '0' }}>
				<Toolbar.Item iconName='tag' text='Tags' onClick={showTagsModal} />
				<Toolbar.Item iconName='money-bill' text='Pagos' onClick={downloadPayments} if={hasAccess(UserAccess.EMPLOYMENTS.VIEW_PAYMENTS)} />
			</Toolbar>
			<Table
				details
				striped
			>
				<Table.Row data={['ID', userData.user_id]}/>
				<Table.Row data={['Nombre', (userData.first_name + ' ' +userData.last_name)]}/>
				<Table.Row className='tags' data={['Tags', <>
					{userData.tags && userData.tags.length > 0 ? (
						userData.tags.map(t=>{
							return <Label key={`USRTG-${t.tag_id}`} color='orange' style={{ marginRight: 5, marginBottom: 5 }}>{t.tag_name}</Label>
						})
					) : (
						'Sin tags'
					)}	
				</>]} />
				<Table.Row data={['Correo electrónico', userData.email]}/>
				<Table.Row data={['RFC', userData.account_rfc || <Icon name='minus' />]}/>
				<Table.Row data={['Código postal', userData.account_postal_code || <Icon name='minus' />]}/>
				<Table.Row data={['Creado', moment.unix(userData.date_created).format('DD/MM/YY HH:mm:ss')]}/>
			</Table>
		</Groupper>
		{}
		{hasAccess(UserAccess.USERS.EDIT_ACCESS) && !userData.superadmin ? (
				<UserAccessConfig 
					accesss={addAccess} 
					onAccessChange={setAddAccess} 
					width={500} 
					style={{ marginBottom: 40, marginTop: 20 }} 
					errorPrompts={errorPrompts} 
					onClick={updateAccess}
				/>
			) : <Groupper title={'Permisos'} width={500} style={{ marginBottom: 15, marginTop: 15 }}>
				<Header text={'Usuario superadmin'} subtext={'Este usuario es un superadmin, ya puede realizar todo en el sistema.'}/>
			</Groupper>
		}
		<Table
			title='Eventos'
			headers={['Evento', 'Nombre','Tipo', 'Fecha', 'Asigno', 'Agregado']}
			style={{ width: 800, margin: 'auto' }}
			selectable
			striped
		>
			{userData.events.length !== 0 ? (
				userData.events.map(e=>(
					<Table.Row
						compact
						key={e.date_id}
						as={Link}
						to={`/events/${e.date_id}`}
						collapsingIndexes={[0,1, 2,3,4, 5]}
						data={[
							e.date_id,
							e.event_name,
							getTypeName(e.type_id),
							moment.unix(e.date).format('DD/MMM/YY HH:mm'),
							e.user_added_name,
							moment.unix(e.date_added).format('DD/MMM/YY HH:mm'),
						]}
					/>
				))
			) : (
				<Table.Cell row className='empty' colSpan={6}>
					Este usuario no tiene eventos
				</Table.Cell>
			)}
		</Table>
		<Table
			fitted
			striped
			title='Archivos'
			headers={['ID', 'Nombre', 'Tipo', 'Creación', 'Creador', <Icon name='wrench' />]}
			collapsingIndexes={[0, 5]}
			style={{ width: 800, margin: 'auto', marginTop: 15 }}
			button={
				<Button
					text="Agregar archivo"
					color="black"
					iconName="plus-circle"
					size="small"
					onClick={() => setShownModal(Modals.CREATE_ASSET)}
				/>
			}
		>
			{userData.assets && userData.assets.length !== 0 ? (
				userData.assets.map(a=>(
					<Table.Row
						key={a.asset_id}
						data={[
							a.asset_id,
							a.asset_name,
							a.user_asset_type_name,
							moment.unix(a.date_created).format('DD/MM/YY HH:mm'),
							a.user_creator_name?.toUpperCase(),
							<Dropdown icon={(
								<div className="fr label" style={{ padding: '3px 10px' }}>
									<Icon name='ellipsis' style={{ margin: 0 }} />
								</div>
								)} className='icon'>
									<Dropdown.Menu>
										<Dropdown.Item onClick={() => { setSelectedAsset(a); setShownModal(Modals.VIEW_ASSET); }}>
											<Icon name="eye" style={{ marginRight: 3 }} /> Ver 
										</Dropdown.Item>
										<Dropdown.Item onClick={() => { setSelectedAsset(a); setShownModal(Modals.DELETE_ASSET); }}>
											<Icon name="close" style={{ marginRight: 3 }} /> Eliminar 
										</Dropdown.Item>
									</Dropdown.Menu>
							</Dropdown>
						]}
					/>
				))
			) : (
				<Table.Cell row className='empty' colSpan={6}>
					No se encontraron archivos
				</Table.Cell>
			)}
		</Table>
		<AssetViewModal
			open={shownModal === Modals.VIEW_ASSET}
			onClose={bindClick(setShownModal, null)}
			asset={selectedAsset}
		/>
		<AssetViewModal
			open={shownModal === Modals.DELETE_ASSET}
			onClose={bindClick(setShownModal, null)}
			asset={selectedAsset}
			delete={true}
			onDeleted={onAssetDeleted}
		/>
		<AddAssetModal
			open={shownModal === Modals.CREATE_ASSET}
			onClose={bindClick(setShownModal, null)}
			userId={userData?.user_id}
			onAdded={onAssetAdded}
		/>
		<Modal open={shownModal===Modals.TAGS} onClose={bindClick(setShownModal, null)} size='mini'>
			<Modal.Header>Editar etiquetas</Modal.Header>
			{!!userData && <Modal.Content>
				{allTags ? (
					<>
						<Dropdown
							placeholder='Seleccionar etiquetas'
							fluid
							multiple
							selection
							value={selectedTags}
							onChange={(e, { value }) => setSelectedTags(value as number[])}
							options={allTags.map(tag => ({
								key: tag.tag_id,
								text: tag.tag_name,
								value: tag.tag_id
							}))}
						/>
						<Message type="error" list={modalPrompts} />
					</>
				) : (
					<Header loading text='Cargando etiquetas' />
				)}
			</Modal.Content>}
			<ModalActions>
				<Button text='Cerrar' basic onClick={bindClick(setShownModal, null)} />
				<Button text='Guardar' color='black' onClick={editTags}/>
			</ModalActions>
		</Modal>
	</div>
}

export default UserView;